module.exports = __webpack_public_path__ + "static/media/editor_badge_ic.a014a3b9.svg";